import { useDripsyTheme, SxProp } from 'dripsy';

import { View } from 'dripsy';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { Dimensions } from 'react-native';

import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { transition } from 'd3';

const Tab = createMaterialTopTabNavigator();

export interface UniTabViewProps {
  tabs: Array<{
    name: string;
    title?: string;
    component?: React.ComponentType<any>;
    children?: React.ReactNode;
  }>;
  sx?: SxProp;
  tabBarScrollEnabled?: boolean;
  animationEnabled?: boolean;
}

export const UniTabView: React.FC<UniTabViewProps> = ({ tabs, sx, tabBarScrollEnabled = true, animationEnabled = true }) => {
  const { theme } = useDripsyTheme();
  const layout = useContext(LayoutContext);

  const COLORS = {
    tabBarActiveTint: theme.colors?.$primary,
    tabBarLabelFocused: theme.colors?.$primary,
    tabBarLabelUnfocused: theme.colors?.$textDisable,
    tabBarIndicator: theme.colors?.$primary,
    tabBarBackgroundColor: 'transparent'
  };

  return (
    <View
      sx={{
        height: layout.isMobile ? Dimensions.get('window').height : 'auto',
        overflow: 'visible',
        zIndex: -1,
        ...sx
      }}>
      <Tab.Navigator
        animationEnabled={false}
        screenOptions={({ navigation }) => ({
          tabBarActiveTintColor: COLORS.tabBarActiveTint,
          tabBarStyle: {
            width: layout.isMobile ? '100%' : 'auto',
            height: theme.space?.$10,
            margin: 0,
            marginHorizontal: layout.isMobile ? 0 : 0,
            backgroundColor: COLORS.tabBarBackgroundColor,
            overflow: 'hidden',
            zIndex: -1
          },
          tabBarItemStyle: {
            width: layout.isMobile ? undefined : 'auto',
            paddingHorizontal: theme.space?.$5
          },
          tabBarLabelStyle: {
            ...theme.text?.textBody,
            margin: 0,
            paddingBottom: theme.space?.$2,
            fontSize: theme.fontSizes?.$3,
            fontWeight: theme.fontWeights?.bold,
            color: navigation.isFocused() ? COLORS.tabBarLabelFocused : COLORS.tabBarLabelUnfocused,
            textTransform: 'none',
            backgroundColor: COLORS.tabBarBackgroundColor
          },
          tabBarIndicatorStyle: {
            backgroundColor: COLORS.tabBarIndicator
          },
          lazy: true
        })}
        sceneContainerStyle={{
          overflow: 'visible'
        }}
        style={{
          overflow: 'visible'
        }}>
        {tabs.map(({ name, children }) => (
          <Tab.Screen key={name} name={name}>
            {(props) => <>{children}</>}
          </Tab.Screen>
        ))}
      </Tab.Navigator>
    </View>
  );
};
